import { Box, IconButton, TextField } from "@material-ui/core";
import dayjs from "dayjs";
import { FC, useState } from "react";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";

import Loader from "../../../components/Loader";
import TooltipPopover from "../../../components/TooltipPopover";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { useNotify, useRefresh } from "react-admin";
import { TimeStampClass } from "../../../types/firebase.types";
import { clientDocRef } from "../../../utils/referencies";

const ClientSuspend: FC<any> = (props) => {
  const suspendedUntil = props.record.suspendedUntil;

  const notify = useNotify();
  const refresh = useRefresh();

  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [latestClientSuspendDate, setLatestClientSuspendDate] = useState<Date>(() =>
    suspendedUntil instanceof TimeStampClass ? suspendedUntil.toDate() : suspendedUntil
  );
  const [ClientSuspendDate, setClientSuspendDate] = useState<Date>(latestClientSuspendDate);

  const formatDate = (date: any = dayjs(), format = "DD-MM-YYYY"): string => dayjs(date).format(format);
  const isSameSuspend = () => formatDate(ClientSuspendDate) === formatDate(suspendedUntil);

  const isBeforeData = suspendedUntil ? dayjs(suspendedUntil.toDate()).isBefore(dayjs()) : null;

  const handleUpdate = () => {
    setLoading(true);

    return new Promise<{ updatedValue: any }>((resolve, reject) => {
      return clientDocRef(props.record.id)
        .update(
          applyUpdateTimestamp({
            suspendedUntil: ClientSuspendDate,
          })
        )
        .then(() => {
          resolve({ updatedValue: formatDate(ClientSuspendDate) });
          notify("Suspend date has been updated", "success");
          setLoading(false);
          setLatestClientSuspendDate(ClientSuspendDate);
          refresh();
        })
        .catch((ex) => {
          reject({ originalValue: formatDate(latestClientSuspendDate) });

          console.log(ex.message);
          notify("Error on updating suspend date", "success");
          setLoading(false);
        });
    });
  };

  const handleSelectClientSuspend = (e: any) => {
    e.stopPropagation();
    setClientSuspendDate(new Date(e.target.value));
  };

  return (
    <>
      {isEdit ? (
        <Box display="flex" alignItems="center">
          <TextField
            type="date"
            variant="outlined"
            size="small"
            onChange={handleSelectClientSuspend}
            onClick={(e: any) => e.stopPropagation()}
            defaultValue={formatDate(ClientSuspendDate, "YYYY-MM-DD")}
            disabled={loading}
            inputProps={{
              min: formatDate(dayjs(), "YYYY-MM-DD"),
              required: true,
            }}
          />
          <Loader loading={loading} size={18}>
            <TooltipPopover message={"Save"}>
              <IconButton size="small" onClick={handleUpdate} disabled={isSameSuspend()}>
                <CheckIcon fontSize="small" color="primary" />
              </IconButton>
            </TooltipPopover>
          </Loader>
          <TooltipPopover message="Cancel">
            <IconButton
              disabled={loading}
              size="small"
              onClick={() => {
                setIsEdit(false);
              }}
            >
              <CloseIcon fontSize="small" color="error" />
            </IconButton>
          </TooltipPopover>
        </Box>
      ) : (
        <Box display="flex" alignItems="center">
          <Box>
            {!!suspendedUntil && !isBeforeData ? (
              <Box style={{ display: "flex", alignItems: "center" }}>
                <CheckIcon style={{ marginRight: 8 }} /> {dayjs(suspendedUntil.toDate()).format("DD/MM/YYYY - hh:mm a")}
              </Box>
            ) : (
              <CloseIcon />
            )}
          </Box>
          <TooltipPopover message="Edit">
            <IconButton
              disabled={loading}
              size="small"
              onClick={() => {
                setIsEdit(true);
              }}
            >
              <EditIcon fontSize="small" color="primary" />
            </IconButton>
          </TooltipPopover>
        </Box>
      )}
    </>
  );
};
export default ClientSuspend;
